import type { Phase } from "../lib/assessment.js";
import styles from "../../../shared/components/shell.module.css";
import own from "./assessment.module.css";

/**
 * Die Einladung zum Test, über den Lektionen.
 *
 * Sie steht ganz oben, wenn ein Test ansteht: er ist der erste Schritt, und ein
 * Kind soll ihn nicht suchen müssen. Der Ton ist bewusst harmlos – gemessen wird
 * hier, nicht bewertet.
 */
export function AssessmentCard({
  phase,
  onStart,
}: {
  phase: Phase;
  onStart: () => void;
}) {
  return (
    <div className={styles.card}>
      <h2 className={own.cardTitle}>
        {phase === "vorher"
          ? "Zuerst: Wie schnell tippst du?"
          : "Geschafft! Und jetzt noch einmal der Text vom Anfang"}
      </h2>
      <p className={styles.subtitle}>
        {phase === "vorher"
          ? "Ein kurzer Text zum Abtippen. Es geht nicht ums Gewinnen – am Ende schauen wir noch einmal und sehen, was du gelernt hast."
          : "Denselben Text hast du am Anfang schon getippt. Jetzt siehst du, was sich verändert hat."}
      </p>
      <button type="button" className={own.button} onClick={onStart}>
        {phase === "vorher" ? "Los geht’s" : "Noch einmal tippen"}
      </button>
    </div>
  );
}
